import * as classnames from 'classnames';
import * as React from 'react';

import { Link } from 'react-router-dom';

import { Logo } from 'components/Logo';
import { Portal } from 'components/Portal';

import './LayoutTitle.scss';

interface LayoutTitleProps {
  className?: string;
  modifier?: 'with-logo';
  title?: string;
}

export class LayoutTitle extends React.Component<LayoutTitleProps, {}> {
  render() {
    const { className, modifier, title } = this.props;
    return (
      <Portal elementId="layout__title-extension">
        <header className={classnames('u-text-center', className)}>
          {modifier === 'with-logo' && <Link to="/"><Logo className="layout-title__logo"/></Link>}
          {title && <h1 className="layout-title__heading o-title-3 u-heavy">{title}</h1>}
        </header>
      </Portal>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Layout/LayoutTitle/LayoutTitle.tsx